import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import InvalidInvitationController from './invalid-invitation.controller';
import { Button as AntButton } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import styles from './styles/reset-password.module.scss';

/**
 * @extends ClockoutController
 * @extends Component
 */
class InvalidInvitation extends Inherit(InvalidInvitationController, Component) {
    render() {
        return (
            <div className={styles.resetContainer}>
                <div className={styles.leftSection}>
                    <div className={styles.logoContainer}>
                        <img src="/logo-color.png" alt="Clockout Logo" className={styles.logo} />
                    </div>
                    
                    <div className={styles.contentWrapper}>
                        <div className={styles.headerSection}>
                            <h1 className={styles.title}>Invalid Link</h1>
                            <p className={styles.subtitle}>
                                We encountered an issue with your link. Please see details on the right.
                            </p>
                        </div>

                        <div className={styles.imageSection}>
                            <img src="/phone-ux.png" alt="Clockout App Preview" className={styles.phoneImage} />
                        </div>
                    </div>
                </div>

                <div className={styles.rightSection}>
                    <div className={styles.formHeader}>
                        <span className={styles.alreadyHaveAccount}>Already have an account?</span>
                        <AntButton 
                            type="text" 
                            onClick={() => this.navigateLogin()}
                            className={styles.signInButton}
                        >
                            Sign in
                        </AntButton>
                    </div>

                    <div className={styles.resetCard}>
                        <div className={styles.loadingContent}>
                            <ExclamationCircleOutlined style={{ fontSize: 64, color: '#f59e0b', marginBottom: 24 }} />
                            <h2 className={styles.formTitle}>Invalid Link</h2>
                            <p className={styles.loadingText}>
                                This link is invalid or has expired. Please contact your administrator for a new link to access your account.
                            </p>
                            <AntButton
                                type="primary"
                                size="large"
                                onClick={() => this.navigateLogin()}
                                className={styles.continueButton}
                                style={{ marginTop: 32 }}
                            >
                                Go to Login
                            </AntButton>
                        </div>
                    </div>
                </div>

                <div className={styles.footer}>
                    <span className={styles.copyright}>Copyright © 2025 Clockout Financial Inc.</span>
                    <div className={styles.footerLinks}>
                        <a href="/terms" className={styles.footerLink}>Terms and Conditions</a>
                        <a href="/privacy" className={styles.footerLink}>Privacy Policy</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default withHooks(InvalidInvitation);

